import { gql } from '@apollo/client';
import { Schema, HousingLoanDetailSchema } from './schema';
import { FileType } from '@jbc-year-end-adj/2024/types';
import { HOUSING_LOAN_FRAGMENT } from './query';

type QueryVariables = {
  input: {
    attributes: {
      housingLoanDeductionApplicableAmount: string;
      housingLoanDeductionApplicableCount: string;
      image?: File | FileType | null;
      certificateImage?: FileType | File | null;
      firstDetail: HousingLoanDetail;
      secondDetail?: HousingLoanDetail;
    };
  };
};

type HousingLoanDetail = {
  deductionClassification: string;
  yearEndBalance: string;
  residenceStartOn: string;
  specialDeduction: string;
  no: number;
};

export const convertFormDataToQueryVariables = (data: Schema): QueryVariables => {
  const firstDetail = convertHousingLoanDetail(data.firstDetail, 1);
  const secondDetail =
    data.housingLoanDeductionApplicableCount === '2' && data.secondDetail ? convertHousingLoanDetail(data.secondDetail, 2) : undefined;

  return {
    input: {
      attributes: {
        housingLoanDeductionApplicableAmount: data.housingLoanDeductionApplicableAmount,
        housingLoanDeductionApplicableCount: data.housingLoanDeductionApplicableCount,
        image: data.image,
        certificateImage: data.certificateImage,
        firstDetail,
        secondDetail
      }
    }
  };
};

export const convertHousingLoanDetail = (housingLoanDetail: HousingLoanDetailSchema, no: number): HousingLoanDetail => {
  return {
    deductionClassification: housingLoanDetail.deductionClassification,
    yearEndBalance: housingLoanDetail.yearEndBalance,
    residenceStartOn: housingLoanDetail.residenceStartOn,
    specialDeduction: housingLoanDetail.specialDeduction,
    no
  };
};

export const ANSWER_HOUSING_LOAN = gql`
  mutation AnswerHousingLoan($input: AnswerHousingLoanInput!) {
    answerHousingLoan(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        ...HousingLoan
      }
    }
  }
  ${HOUSING_LOAN_FRAGMENT}
`;
